import { Dayjs } from "dayjs"
import {
  EnergyUsageFuelType,
  EnergyUsageGranularity,
} from "@/api/backofficeRest/generated/model"
import { IEnergyUsage, IEnergyUsageValue } from "./energyUsage.types"

export class EnergyUsageValue implements IEnergyUsageValue {
  startDate: Dayjs
  endDate: Dayjs
  kwh: number | null
  cost: number | null

  constructor(
    startDate: Dayjs,
    endDate: Dayjs,
    kwh: number | null,
    cost: number | null,
  ) {
    this.startDate = startDate
    this.endDate = endDate
    this.kwh = kwh
    this.cost = cost
  }
}

export class EnergyUsage implements IEnergyUsage {
  meterpointId: number
  registerId: number
  rateName: string
  fuelType: EnergyUsageFuelType
  granularity: EnergyUsageGranularity
  startDate: Dayjs
  endDate: Dayjs
  values: IEnergyUsageValue[]

  constructor(options: {
    meterpointId: number
    registerId: number
    rateName: string
    fuelType: EnergyUsageFuelType
    granularity: EnergyUsageGranularity
    startDate: Dayjs
    endDate: Dayjs
    values: IEnergyUsageValue[]
  }) {
    this.meterpointId = options.meterpointId
    this.registerId = options.registerId
    this.rateName = options.rateName
    this.fuelType = options.fuelType
    this.granularity = options.granularity
    this.startDate = options.startDate
    this.endDate = options.endDate
    this.values = options.values
  }

  get hasValues(): boolean {
    return this.values.some((v) => v.kwh !== null || v.cost !== null)
  }
}
